import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Menu = () => {
  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState('all');

  useEffect(() => {
    fetchMenu();
  }, []);

  const fetchMenu = async () => {
    try {
      const response = await axios.get('/api/menu');
      setMenuItems(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
    }
  };

  const filteredItems = category === 'all' 
    ? menuItems 
    : menuItems.filter(item => item.category === category);

  const categories = ['all', 'Matcha Drinks', 'Bowls', 'Sandwiches', 'Refreshers'];

  if (loading) return <div style={styles.loading}>Loading menu...</div>;

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>GlowFlex Cafe Menu</h1>
      <p style={styles.subtitle}>Healthy fuel for your fitness journey</p>
      <p style={styles.notice}>Visit us in-person to order - No online ordering available</p>

      {/* Category Filter */}
      <div style={styles.filters}>
        {categories.map(cat => (
          <button
            key={cat}
            onClick={() => setCategory(cat)}
            style={{
              ...styles.filterBtn,
              background: category === cat ? 'linear-gradient(135deg, #FFA8B9, #7AB845)' : 'white',
              color: category === cat ? 'white' : '#2C2C2C'
            }}
          >
            {cat === 'all' ? 'All Items' : cat}
          </button>
        ))}
      </div>

      {/* Menu Grid */}
      <div style={styles.grid}>
        {filteredItems.map(item => (
          <div key={item._id} style={styles.card}>
            {/* Unavailable Overlay */}
            {!item.isAvailable && (
              <div style={styles.unavailableOverlay}>
                <span style={styles.unavailableBadge}>Currently Unavailable</span>
              </div>
            )}

            <div style={styles.imageContainer}>
              {item.image ? (
                <img src={item.image} alt={item.name} style={styles.image} />
              ) : (
                <div style={styles.imagePlaceholder}>
                  {item.category === 'Matcha Drinks' && '🍵'}
                  {item.category === 'Bowls' && '🥗'}
                  {item.category === 'Sandwiches' && '🥪'}
                  {item.category === 'Refreshers' && '🧃'}
                </div>
              )}
            </div>

            <div style={styles.cardContent}>
              <span style={styles.categoryBadge}>{item.category}</span>
              <h3 style={styles.itemName}>{item.name}</h3>
              <p style={styles.description}>{item.description}</p>
              <div style={styles.price}>KES {item.price}</div>
            </div>
          </div>
        ))}
      </div>

      {filteredItems.length === 0 && (
        <p style={styles.noItems}>No items in this category</p>
      )}
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '1400px',
    margin: '0 auto',
    padding: '2rem'
  },
  loading: {
    textAlign: 'center',
    padding: '4rem',
    fontSize: '1.2rem'
  },
  title: {
    fontSize: '3rem',
    textAlign: 'center',
    marginBottom: '1rem',
    fontFamily: 'Playfair Display, serif'
  },
  subtitle: {
    textAlign: 'center',
    fontSize: '1.2rem',
    color: '#5A5A5A',
    marginBottom: '1rem'
  },
  notice: {
    textAlign: 'center',
    background: 'linear-gradient(135deg, rgba(255,168,185,0.2), rgba(122,184,69,0.2))',
    padding: '1rem',
    borderRadius: '12px',
    marginBottom: '2rem',
    fontWeight: 600,
    color: '#2C2C2C'
  },
  filters: {
    display: 'flex',
    gap: '1rem',
    justifyContent: 'center',
    marginBottom: '3rem',
    flexWrap: 'wrap'
  },
  filterBtn: {
    padding: '0.75rem 1.5rem',
    border: '2px solid #ddd',
    borderRadius: '25px',
    cursor: 'pointer',
    fontWeight: 600,
    transition: 'all 0.3s'
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
    gap: '2rem'
  },
  card: {
    position: 'relative',
    background: 'white',
    borderRadius: '20px',
    boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
    overflow: 'hidden',
    transition: 'transform 0.3s'
  },
  unavailableOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(255, 255, 255, 0.85)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10,
    backdropFilter: 'blur(2px)'
  },
  unavailableBadge: {
    background: '#F44336',
    color: 'white',
    padding: '0.75rem 1.5rem',
    borderRadius: '25px',
    fontSize: '1rem',
    fontWeight: 700,
    boxShadow: '0 4px 12px rgba(244, 67, 54, 0.3)'
  },
  imageContainer: {
    width: '100%',
    height: '200px',
    background: 'linear-gradient(135deg, #FFF9F5, #F5F5F5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },
  imagePlaceholder: {
    fontSize: '4rem'
  },
  cardContent: {
    padding: '1.5rem'
  },
  categoryBadge: {
    background: 'linear-gradient(135deg, #FFA8B9, #FF85A1)',
    color: 'white',
    padding: '0.25rem 0.75rem',
    borderRadius: '20px',
    fontSize: '0.85rem',
    fontWeight: 600
  },
  itemName: {
    fontSize: '1.5rem',
    margin: '1rem 0 0.5rem',
    color: '#2C2C2C'
  },
  description: {
    color: '#5A5A5A',
    lineHeight: 1.6,
    marginBottom: '1rem'
  },
  price: {
    fontSize: '1.5rem',
    fontWeight: 700,
    color: '#7AB845'
  },
  noItems: {
    textAlign: 'center',
    fontSize: '1.2rem',
    color: '#5A5A5A',
    padding: '3rem'
  }
};

export default Menu;